/**
 * Size tokens are currently not exposed for users (therefore not available in theme)
 */
export const size = {
  /** 0 px */
  0: 0,
  /** 1 px */
  1: 1,
  /** 2 px */
  2: 2,
  /** 3 px */
  3: 3,
  /** 4 px */
  4: 4,
  /** 5 px */
  5: 5,
  /** 6 px */
  6: 6,
  /** 7 px */
  7: 7,
  /** 8 px */
  8: 8,
  /** 10 px */
  10: 10,
  /** 12 px */
  12: 12,
  /** 14 px */
  14: 14,
  /** 15 px */
  15: 15,
  /** 16 px */
  16: 16,
  /** 18 px */
  18: 18,
  /** 20 px */
  20: 20,
  /** 24 px */
  24: 24,
  /** 26 px */
  26: 26,
  /** 28 px */
  28: 28,
  /** 30 px */
  30: 30,
  /** 31 px */
  31: 31,
  /** 32 px */
  32: 32,
  /** 33 px */
  33: 33,
  /** 34 px */
  34: 34,
  /** 36 px */
  36: 36,
  /** 37 px */
  37: 37,
  /** 38 px */
  38: 38,
  /** 40 px */
  40: 40,
  /** 42 px */
  42: 42,
  /** 44 px */
  44: 44,
  /** 46 px */
  46: 46,
  /** 48 px */
  48: 48,
  /** 50 px */
  50: 50,
  /** 52 px */
  52: 52,
  /** 56 px */
  56: 56,
  /** 59 px */
  59: 59,
  /** 60 px */
  60: 60,
  /** 62 px */
  62: 62,
  /** 64 px */
  64: 64,
  /** 66 px */
  66: 66,
  /** 72 px */
  72: 72,
  /** 78px */
  78: 78,
  /** 80 px */
  80: 80,
  /** 82 px */
  82: 82,
  /** 84 px */
  84: 84,
  /** 86 px */
  86: 86,
  /** 90 px */
  90: 90,
  /** 94 px */
  94: 94,
  /** 96 px */
  96: 96,
  /** 100 px */
  100: 100,
  /** 114 px */
  114: 114,
  /** 120 px */
  120: 120,
  /** 122 px */
  122: 122,
  /** 124 px */
  124: 124,
  /** 132 px */
  132: 132,
  /** 140 px */
  140: 140,
  /** 160 px */
  160: 160,
  /** 172 px */
  172: 172,
  /** 176 px */
  176: 176,
  /** 196 px */
  196: 196,
  /** 192 px */
  192: 192,
  /** 198 px */
  198: 198,
  /** 200 px */
  200: 200,
  /** 208 px */
  208: 208,
  /** 240 px */
  240: 240,
  /** 245 px */
  245: 245,
  /** 250 px */
  250: 250,
  /** 256 px */
  256: 256,
  /** 264 px */
  264: 264,
  /** 300 px */
  300: 300,
  /** 314 px */
  314: 314,
  /** 360 px */
  360: 360,
  /** 400 px */
  400: 400,
  /** 584 px */
  584: 584,
  /** 640 px */
  640: 640,
  /** 760 px */
  760: 760,
  /** 800 px */
  800: 800,
  /** 1024 px */
  1024: 1024,
  /** 1136 px */
  1136: 1136,
} as const;

export type Size = typeof size;
